import React, { useEffect } from 'react';

// Style
import 'driver.js/dist/driver.css';

// Lib
import { driver } from 'driver.js';
import { shallowEqual } from 'react-redux';
import { setDriverInstance } from 'lib/driver';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// Actions
import { modalClose } from 'reducers/modal';
import { markTutorialSeen } from 'reducers/settings';

// Constants
import {
	toursConfig
} from 'constans/tutorial';

interface Props {
	tutorialKey: string | null;
	data?: any;
}

const configModal = [
	'#projects-modal-add'
];

export const TutorialManager: React.FC<Props> = ({ data, tutorialKey }) => {
	const dispatch = useAppDispatch();

	const isModalOpen = useAppSelector(
		(s) => s.modal.openModal,
		shallowEqual
	);
	const modal = useAppSelector(
		(s) => s.modal,
		shallowEqual
	);

	useEffect(() => {
		if (!tutorialKey) return;

		// @ts-ignore
		const steps = toursConfig[tutorialKey];
		if (!steps) return;

		const driverObj = driver({
			showProgress: true,
			steps,
			onNextClick: async (el, step, opts) => {
				if ((step as any).action) {
					await (step as any).action({ opts, dispatch, data });
				}
			},
			onPrevClick: async (el, step, opts) => {
				const element = step?.element || '';
				if (configModal.includes(element as string)) {
					dispatch(modalClose());
				}
				opts.driver.movePrevious();
			},
			onDestroyed: () => {
				dispatch(markTutorialSeen(tutorialKey));
				window.dispatchEvent(new CustomEvent('tutorial-seen', { detail: tutorialKey }));
			}
		});

		setDriverInstance(driverObj);
		driverObj.drive();

		return () => {
			try {
				window.dispatchEvent(new CustomEvent('tutorial-seen', { detail: tutorialKey }));
			} catch {
			}
		};
	}, [tutorialKey, data, dispatch, isModalOpen, modal]);

	return null;
};

export default TutorialManager;
